<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">供应商准入审批</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="18">
        <el-form ref="form" :model="form" label-width="130px" class="form">
          <!-- <el-form-item label="需求类型">
            <el-radio-group v-model="form.type" class="type-radio-type">
              <el-radio-button label="0">集团需求</el-radio-button>
              <el-radio-button label="1">子公司需求</el-radio-button>
            </el-radio-group>
          </el-form-item> -->

          <purchase-supplier ref="apply" :type="1" :userData="userData" :formByFather="form"></purchase-supplier>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments ref="attachments" style="margin-left:-10px;" :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <!-- <approval-item-by-custom ref="approval" :defaultApprovalUsers="defaultApprovalUsers" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item-by-custom> -->
              
            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsersData" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>


          <el-form-item label="">
            <el-button :loading="formLoading" @click="SubmitApply()" class="form-btn" type="success">确认提交供应商准入申请审批
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </div>


  </div>
</template>
<script>
  import {
    mapState
  } from "vuex";

  import approvalUsers from '@/Mixins/approvalUsers'
  // import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import Attachments from '@/components/Attachments'
  import ApprovalItem from '@/components/ApprovalItem'

  import PurchaseSupplier from '@/page/form/purchase/supplier'
  export default {
    components: {
      ApprovalItem,
      PurchaseSupplier,
      ApprovalItem,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        formLoading: false,
        form: {
          name: '',
          productName: '',
          remark: '',
          depId: '',
          json: true,
        },
        // 附件
        attachmentArr: [],
        // 审批
        approvalType: "0",

        defaultApprovalUsers: "",
        selectArr: [],
        approvalSetDep: {},
      }
    },
    created() {
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
      }

      // 默认选择需求类型
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
      if (this.form.depId == 7) {
        this.form.type = "0"
      } else {
        this.form.type = "1"
      }

      this.approvalUsersData = this.approvalUsers['c120']
      this.getApplyData()
    },
    methods: {
      // 获取审批表原内容
      getApplyData() {
        this.hasApplyId = this.form.applyId ? true : false
        if (this.form.applyId) {
          this.formLoading = true
          this.getProjectApplyInfo()
        } else {
          this.setSelectArr(this.applyInfo, 120)
        }
      },
      // 获取原审批表内容
      getProjectApplyInfo() {
        ajax.get('/purchase/supplier/apply/info/' + this.form.applyId, '', (res) => {
          this.applyInfo = res.vo
          this.form = res.vo
          // this.selectArr = this.form.flow.approvals.map(item => item.user)
          this.form.applyId = this.form.flow.applyId
          this.form.json = true

          if (this.form.projectIds) {
            this.form.projectIds = this.form.projectIds.split(",").map(Number)
          } else {
            this.form.projectIds = []
          }

          this.attachmentArr = this.applyInfo.attachments ? this.applyInfo.attachments : []
          this.setSelectArr(this.applyInfo, 120)
          this.formLoading = false
        })
      },
      // 提交使用采购申请单
      SubmitApply() {
        this.form = this.$refs.apply.getFromData()
        // this.form.projectIds = this.form.projectIds ? this.form.projectIds.join(",") : ''

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        if (!this.form.approvalUserIds) {
          this.$message.error('审批人员不能一个都不选择')
          return
        }
        this.form.attachments = this.$refs.attachments.getAttachments()

        this.formLoading = true
        let _url = !this.form.applyId ? '/purchase/supplier/apply/add' : '/purchase/supplier/apply/edit?applyId=' + this.form
          .applyId

        ajax.post(_url, this.form, (res) => {
          this.formLoading = false
          if (!this.form.applyId) {
            this.$message.success("提交供应商准入申请成功，请耐心等待领导审批")
          } else {
            this.$message.success("修改供应商准入申请成功，请耐心等待领导审批")
          }
          this.$router.push('/Purchase/Supplier/List')
        }, (res) => {
          this.formLoading = false
        })
      },
    },
    watch: {
      'form.type'() {
        this.approvalUsersData = this.approvalUsers['c120']
        this.setSelectArr(this.applyInfo, 120)
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/purchase/supplierApply.vue